// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"6360b832","571":"9018388a","737":"16e3eb96"}[chunkId] + ".chunk.js";
};